import api from "./axios";
import { getCookie } from "../hooks/useCookies";

const token = getCookie("token");

export const resendMail = async () => {
    try {
        const response = await api.post(`/api/v1/user/verify`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const checkVerificationEmail = async () => {
    try {
        const response = await api.get(`/api/v1/user/check-email-verification`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const signupCode = async (data) => {
    try {
        const response = await api.post(`/api/v1/user/signup`,data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}
export const signupOtp = async (data) => {
    try {
        const response = await api.post(`/api/v1/user/signup/otp`,data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}